/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Button,
  Flex,
  Hide,
  Image,
  Link,
  Show,
  Spacer,
  Text,
} from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { useProgramLanguageSelection } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
import SingleImage from '@ieo/Components/SingleImage';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */
/* Config */
import config from '@config';
import { TopBannerSt } from '@ieo/Common/CompLangConfig';
import DayTimeCounter from '@ieo/Components/Timer/DayTimeCounter';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';
import { AuthContext } from '@store/auth-context';
import { IoCloseCircleSharp } from 'react-icons/io5';

/* Styles */

/**
 * @param {Object} sectionContent
 * @param {Object} pageData
 * @param {String} lang
 * @param {String} region
 * @returns
 */
const RemrktTopBanner = ({
  sectionContent,
  region,
  lang,
  pageData,
  pageName,
  prgData,
}) => {
  // console.log('🚀 ~ pageData:==>', pageData);
  const [isCatOpen, setCatIsOpen] = useState(false);
  // const [hover, setHover] = useState(false);
  // const [resultArr, setResultArr] = useState([]);
  // const [isBannerActive, setIsBannerActive] = useState(false);
  const router = useRouter();
  const { setProgramLanguage } = useProgramLanguageSelection();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [showTimer, setShowTimer] = useState(false);
  const [isBannerActive, setIsBannerActive] = useState(false);

  // const [descText, setDescText] = useState(sectionContent[2]);
  // const [isLoader, setIsLoader] = useState(false);
  // const programFeeLink = sectionContent?.find(
  //   e => e.fieldId === 'pc-program-fee'
  // );

  // const registerText = sectionContent?.find(
  //   e => e.fieldId === 'remrkt-top-register-text'
  // );

  // const changeUi = router.asPath.indexOf('inner-engineering-pc') > 0;

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    setIsLoggedIn(authCtx.isLoggedIn);
  }, [authCtx.isLoggedIn]);

  const currentCoupon = Object.values(prgData)[0]?.coupon;

  // Set local time
  const currentDate = new Date();
  const getLocalTime =
    currentDate.getFullYear() +
    '-' +
    String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(currentDate.getDate()).padStart(2, '0') +
    'T' +
    String(currentDate.getHours()).padStart(2, '0') +
    ':' +
    String(currentDate.getMinutes()).padStart(2, '0') +
    ':' +
    String(currentDate.getSeconds()).padStart(2, '0');

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  useEffect(() => {
    if (
      // (
      // changeUi ||
      // router.asPath.split('?')[0].endsWith('inner-engineering') ||
      // router.asPath.split('#')[0].endsWith('inner-engineering')) &&
      isThemeActive &&
      pageConfigVal?.topbanner?.topAd?.countDown &&
      !showTimer
    ) {
      setShowTimer(true);
    }
  }, [isThemeActive]);

  // const RightIcon = ({ hover }) => {
  //   return (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //     >
  //       <path
  //         d="M4 9L12 17L20 9"
  //         stroke={hover ? '#BC570F' : '#F37021'}
  //         strokeWidth="2.66667"
  //       />
  //     </svg>
  //   );
  // };

  useEffect(() => {
    // setDescText(sectionContent[2]);
    setProgramLanguage(router.query.lang || lang);
    // const langArr = [];
    // config.orderedLang.forEach(language => {
    //   const newProgs = pageData?.alsoin?.filter(itm => {
    //     return (
    //       itm.url ===
    //       window?.location?.pathname.replace(`/${lang}/`, `/${language}/`)
    //     );
    //   });
    //   if (newProgs?.length > 0) {
    //     langArr.push(newProgs[0]);
    //   }
    // });
    // setResultArr(langArr);
  }, [isCatOpen, router.query.lang, router.asPath]);

  // const buttonSt = changeUi ? 'uiChangeButtonText' : 'buttonText';

  // console.log('===>>.', sectionContent);

  const whiteBannerText1 = sectionContent?.find(
    e => e.fieldId === 'white-banner-text1'
  );
  const whiteBannerText2 = sectionContent?.find(
    e => e.fieldId === 'white-banner-text2'
  );
  const whiteBannerText3 = sectionContent?.find(
    e => e.fieldId === 'white-banner-text3'
  );

  return (
    <>
      {router.asPath && (
        <Box
          background={{
            base: ` url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
            md: ` url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
            lg: ` url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
            xl: ` url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
          }}
          bgColor={'#00005B'}
          backgroundSize="cover"
          position="relative"
        >
          {/* top white sticky anner */}
          {whiteBannerText1 &&
            whiteBannerText2 &&
            !isBannerActive &&
            isThemeActive &&
            pageConfigVal?.topbanner?.topAd &&
            Object.values(prgData)?.length > 0 &&
            Object.values(prgData)[0]?.coupon && (
              <Box maxWidth="1920px" w="100%" pos="fixed" top="0" zIndex="999">
                <Link href="#ieo-program-fees" _hover={{ textDecor: 'none' }}>
                  {!isMobile && (
                    <Hide below="xs">
                      <Flex
                        bgImage={{
                          base: pageConfigVal?.topbanner?.topAd?.mob,
                          md: pageConfigVal?.topbanner?.topAd?.mob,
                          lg: pageConfigVal?.topbanner?.topAd?.desktop,
                          xl: pageConfigVal?.topbanner?.topAd?.bigScreen,
                        }}
                        h="80px"
                        py="14px"
                        bgSize="cover"
                        w="100%"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Flex flexDir="row">
                          <StructuredTextParser
                            color="#CD3C4C"
                            textAlign="center"
                            mt="0"
                            fontFamily="FedraSerifAStdBook"
                            fontSize={{ md: '30px', lg: '41px' }}
                            fontStyle="normal"
                            fontWeight="600"
                            lineHeight={{ md: '37px', lg: '49px' }}
                            str={render(whiteBannerText1?.body)}
                            paddingRight="25px"
                            letterSpacing="1.7px"
                          />
                          <Flex alignItems="center">
                            {whiteBannerText3 && showTimer && (
                              <StructuredTextParser
                                str={render(whiteBannerText3?.body)}
                                pl="22px"
                                pr="20px"
                                color="#325732"
                                textAlign="center"
                                fontFeatureSettings="'case' on"
                                fontFamily="FedraSansStd-medium"
                                fontSize={{ md: '22px', lg: '32px' }}
                                mt="0"
                              />
                            )}
                            {whiteBannerText3 && !showTimer && (
                              <StructuredTextParser
                                pl="22px"
                                color="#C07513"
                                textAlign="center"
                                fontFamily="FedraSansStd-medium"
                                fontSize={{ md: '12px', lg: '24px' }}
                                mt="0"
                                str={render(whiteBannerText3?.body)}
                              />
                            )}
                          </Flex>
                          {showTimer && (
                            <Box pl={{ base: '0px', lg: 5 }}>
                              <DayTimeCounter
                                currentDate={getLocalTime}
                                endDate={currentCoupon?.expiryDate}
                                sectionContent={sectionContent}
                                isMobile={isMobile}
                                color="#cd3c4c"
                              />
                            </Box>
                          )}
                        </Flex>
                      </Flex>
                    </Hide>
                  )}
                  {isMobile && (
                    <Show below="md">
                      {/* <Image src={pageConfigVal?.topbanner?.topAd?.mob} alt="" /> */}
                      <Flex
                        bgImage={pageConfigVal?.topbanner?.topAd?.mob}
                        py="11.5px"
                        px="15px"
                        bgSize="cover"
                        w="100%"
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        <Flex flexDir="column">
                          <StructuredTextParser
                            color="#CD3C4C"
                            textAlign="center"
                            display="flex"
                            alignItems={'center'}
                            fontFamily="FedraSerifAStdBook"
                            mt="0"
                            fontSize="19px"
                            fontStyle="normal"
                            flexDir="column"
                            fontWeight="500"
                            lineHeight="23px"
                            verticalAlign="middle"
                            str={render(whiteBannerText1?.body)}
                            letterSpacing="1px"
                          />
                          <Flex alignItems="center">
                            {whiteBannerText3 && showTimer && (
                              <StructuredTextParser
                                str={render(whiteBannerText3?.body)}
                                as="span"
                                mt="0"
                                color="#325732"
                                textAlign={'center'}
                                fontFeatureSettings="'case' on"
                                fontFamily="FedraSansStd-medium"
                                fontSize="16px"
                              />
                            )}
                            {whiteBannerText3 && !showTimer && (
                              <StructuredTextParser
                                pl="9px"
                                color="#C07513"
                                textAlign={'center'}
                                fontFamily="FedraSansStd-medium"
                                fontSize="12px"
                                lineHeight="14px"
                                mt="0"
                                str={render(whiteBannerText3?.body)}
                              />
                            )}
                          </Flex>
                          {showTimer && (
                            <Flex
                              alignItems="center"
                              justifyContent="center"
                              w="100%"
                            >
                              <DayTimeCounter
                                currentDate={getLocalTime}
                                endDate={currentCoupon?.expiryDate}
                                sectionContent={sectionContent}
                                isMobile={isMobile}
                                color="#c07513"
                              />
                            </Flex>
                          )}
                        </Flex>
                      </Flex>
                    </Show>
                  )}
                </Link>

                <Box
                  position="absolute"
                  right={{ base: '5%', md: '4%', lg: '3%', xl: '5%' }}
                  bottom="30%"
                >
                  <Hide below="md">
                    <IoCloseCircleSharp
                      cursor="pointer"
                      onClick={() => {
                        setIsBannerActive(true);
                      }}
                      fontSize={'37px'}
                      color="#000"
                    />
                  </Hide>
                  <Show below="md">
                    <IoCloseCircleSharp
                      cursor="pointer"
                      onClick={() => {
                        setIsBannerActive(true);
                      }}
                      fontSize={'23px'}
                      color="#000"
                    />
                  </Show>
                </Box>
              </Box>
            )}

          <Box
            id="top-banner-container"
            display={{ base: 'flex', md: 'block' }}
            flexDir={{ base: 'column', md: 'row' }}
            justifyContent="space-between"
            h={{ base: '720px', sm: '100%', md: '625px', lg: '100%' }}
            maxW="100%"
            pos="relative"
            className="topBannerContainer"
            minH={{ base: 'auto', sm: 'auto', lg: '733px' }}
          >
            <Flex
              width={{
                base: '100%',
                md: '90%',
                lg: '95%',
                xl: '1130px',
              }}
              mx="auto"
              height="auto"
              justifyContent={{ base: 'space-between', sm: 'flex-end' }}
              alignItems="center"
              px={{ base: '30px', md: '0' }}
              gap={{ base: '8px', md: '0px' }}
            >
              {!isMobile && (
                <SingleImage
                  mt={{ base: '20px', md: '70px', lg: '20px' }}
                  mx="0px"
                  className="textImage"
                  objectFit="contain"
                  alignSelf={{
                    base: 'center',
                    md: 'flex-start',
                  }}
                  w="170px"
                  maxW={'170px'}
                  sectionContent={sectionContent[0]}
                  alt="in 7 step transform your life"
                  sync="true"
                />
              )}

              {pageData?.alsoin?.length > 0 ? (
                <Button
                  id="banner-language-switcher"
                  bg="transparent"
                  value={config.lngListTrans[lang]}
                  color="#B7987E"
                  fontSize={{ base: '16px', md: '18px' }}
                  variant="link"
                  w={{ base: 'auto', md: '150px' }}
                  h={{ base: '20px', md: '21px' }}
                  rounded="full"
                  fontWeight={350}
                  display="inline-flex"
                  _hover={{ border: '0px solid #B7987E' }}
                  _focus={{ border: '0px solid #B7987E' }}
                  _active={{ border: '0px solid #B7987E' }}
                  // rightIcon={<RightIcon hover={hover} />}
                  onClick={() => setCatIsOpen(!isCatOpen)}
                  className="selectButton"
                  textTransform="capitalize"
                  {...TopBannerSt[lang]?.loginButton}
                  mr={{ base: '25px', md: '30px' }}
                  mt={{
                    base: '35px',
                    md: '35px',
                  }}
                  justifyContent="end"
                >
                  <Text
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    color={'#F37021'}
                    // _hover={{ color: '#BC570F' }}
                    w="auto"
                    minW="60px"
                    {...TopBannerSt[lang]?.loginButton}
                  >
                    {config.lngListTrans[lang]}
                  </Text>
                  {/* {isCatOpen && (
                    <Flex
                      whiteSpace="break-spaces"
                      className="options"
                      alignItems="flex-start"
                      alignContent="flex-start"
                      {...TopBannerSt[lang]?.loginButton}
                      position="absolute"
                      top={{ base: '45px', md: '47px' }}
                      zIndex="100"
                      left="0"
                      boxShadow="0px 0.75926px 2.36111px 0px rgba(0, 0, 0, 0.03), 0px 3.34074px 4.88889px 0px rgba(0, 0, 0, 0.05), 0px 8.2px 9.75px 0px rgba(0, 0, 0, 0.06), 0px 15.79259px 19.11111px 0px rgba(0, 0, 0, 0.07), 0px 26.57407px 35.13889px 0px rgba(0, 0, 0, 0.09), 0px 41px 60px 0px rgba(0, 0, 0, 0.12)"
                      w={{ base: '103px', md: '116px' }}
                      flexDir="column"
                      bg="#ffffff"
                      mt={{ base: '0', md: '0' }}
                      p={{ base: '10px 15px', md: '10px 15px' }}
                    >
                      {region === 'in'
                        ? resultArr?.map((lg, i) => {
                            return (
                              <Box
                                padding="8px 0px"
                                cursor="pointer"
                                key={nanoid()}
                                value={lg}
                              >
                                <Text
                                  textAlign="left"
                                  fontFamily={TopBannerSt[lang].loginButton}
                                >
                                  <NextLink
                                    href={lg?.url}
                                    passHref
                                    legacyBehavior
                                  >
                                    <Link
                                      color="#6D6358"
                                      {...TopBannerSt[lang]?.loginButton}
                                      textAlign="left"
                                      _hover={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                      _active={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                      _focus={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                    >
                                      {lg.title}
                                    </Link>
                                  </NextLink>
                                </Text>
                              </Box>
                            );
                          })
                        : pageData.alsoin?.map((lg, i) => {
                            return (
                              <Box
                                padding="8px 0px"
                                cursor="pointer"
                                key={nanoid()}
                                value={lg}
                              >
                                <Text
                                  textAlign="left"
                                  fontFamily={TopBannerSt[lang].loginButton}
                                >
                                  <NextLink
                                    href={lg?.url}
                                    passHref
                                    legacyBehavior
                                  >
                                    <Link
                                      color="#6D6358"
                                      {...TopBannerSt[lang]?.loginButton}
                                      textAlign="left"
                                      _hover={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                      _active={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                      _focus={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                    >
                                      {lg.title === 'Indonesian'
                                        ? 'Bahasa Indonesia'
                                        : lg.title}{' '}
                                    </Link>
                                  </NextLink>
                                </Text>
                              </Box>
                            );
                          })}

                      {sectionContent[3].linkUrl != '' && (
                        <Box
                          display={{ base: 'none', md: 'flex' }}
                          flexDir={!programFeeLink?.linkUrl && 'column'} // dir for ui update
                          ml={{
                            base: 'auto',
                            md: '2px',
                            lg: 'auto',
                          }}
                          mr={{ base: 'auto', md: '0', lg: 'auto' }}
                          h="auto"
                          alignSelf={{
                            base: 'center',
                            md: lang == 'ar' ? 'auto' : 'flex-start',
                            lg: 'center',
                          }}
                          to="ieo-enroll-section"
                          spy={true}
                          smooth="true"
                          offset={50}
                        >
                          <SimpleButton
                            id="ieo-register-banner-btn"
                            minW="230px"
                            background={
                              '#F37021 !important' ||
                              (isThemeActive && pageConfigVal?.btn?.bgColor)
                            }
                            h={{ base: '50px', md: '60px', lg: '60px' }}
                            textAlign="center"
                            mb={programFeeLink?.linkUrl ? '0' : '5px'}
                            mx={{ base: 'auto', md: '0', lg: 'auto' }}
                            _hover={{
                              background:
                                '#BC570F !important' ||
                                (isThemeActive &&
                                  pageConfigVal?.btn?.bgHoverColor),
                            }}
                            borderRadius={
                              region === 'us' || region === 'ca'
                                ? '120px !important'
                                : isThemeActive
                                ? '50px !important'
                                : '10px !important'
                            }
                            style={sectionContent[3]}
                            srcImg={pageData}
                            clickHandler={() => {
                              gtmClick();
                            }}
                            padding={{
                              base: '8px 7px',
                              md:
                                isThemeActive &&
                                pageConfigVal?.btn?.bgHoverColor
                                  ? '10px 0'
                                  : '10px 25px',
                              lg:
                                isThemeActive &&
                                pageConfigVal?.btn?.bgHoverColor
                                  ? '12px 10px'
                                  : '10px 29px',
                            }}
                            lineHeight={{
                              base: '1.5em',
                              md:
                                lang == 'hi' || lang == 'kn' || lang == 'te'
                                  ? '50px'
                                  : '37px',
                            }}
                            // mt={{ base: '0', md: '30px', lg: '40px' }} ui update
                            mt={{ base: '0', md: '30px', lg: '50px' }}
                            zIndex={100}
                            icon={isThemeActive && pageConfigVal?.btn?.icon}
                            {...TopBannerSt[lang][buttonSt]}
                          />

                          {programFeeLink?.linkUrl && (
                            <NextLink
                              legacyBehavior
                              href={refineUrlDomain(
                                programFeeLink?.linkUrl,
                                region,
                                lang
                              )}
                              passHref
                            >
                              <Link
                                w="100%"
                                mt={{ base: '0', md: '20px', lg: '20px' }}
                                color="#fff"
                                fontSize={{ base: '16px', md: '18px' }}
                                lineHeight={{ base: '21.44px', md: '25.2px' }}
                                fontFamily={
                                  lang
                                    ? config.langFont[lang]
                                    : 'FedraSansStd-medium'
                                }
                                fontWeight="normal"
                                textAlign={{
                                  base: 'center',
                                  sm: 'left',
                                  lg: 'center',
                                }}
                                ml={{
                                  base: '0',
                                  sm: '100px',
                                  md: isGiftPage ? '15px' : '35px',
                                  lg: '0',
                                }}
                                mb={{ base: '20px', md: '30px' }}
                                textDecor="underline"
                                cursor="pointer"
                              >
                                {programFeeLink?.buttonText}
                              </Link>
                            </NextLink>
                          )}
                          {sectionContent[13]?.body && (
                            <StructuredTextParser
                              str={render(sectionContent[13]?.body)}
                              position="relative"
                              fontFamily="FedraSansStd-book, sans-serif"
                              className="highlightText"
                              color="#fff"
                              dir={lang == 'ar' ? 'rtl' : 'ltr'}
                            />
                          )}
                        </Box>
                      )}
                    </Flex>
                  )} */}
                </Button>
              ) : (
                <Spacer />
              )}
              {(region === 'us' || region === 'ca' || lang === 'es') &&
                sectionContent[8]?.linkUrl &&
                sectionContent[8]?._modelApiKey === 'simple_button' && (
                  <Flex
                    flexDir="column"
                    alignItems="flex-end"
                    justify="space-between"
                  >
                    <NextLink
                      href={refineUrlDomain(
                        sectionContent[8]?.linkUrl,
                        region,
                        lang
                      )}
                      passHref
                      legacyBehavior
                    >
                      <Link
                        {...TopBannerSt[lang]?.loginButton}
                        color={{ base: '#fff' }}
                        bg={
                          region === 'us' || region === 'ca'
                            ? '#F37021'
                            : '#CE6113'
                        }
                        fontWeight={500}
                        height={{ base: '100%', md: '43px' }}
                        padding={{
                          base: '5px 21px',
                          md: '5px 30px 11px',
                          lg: '8px 10px',
                        }}
                        fontSize={{ base: '14px', md: '18px' }}
                        borderRadius={0}
                        textAlign="center"
                        w={{ base: 'auto', lg: '136px' }}
                        _hover={{ bg: '#BC570F' }}
                        _active={{ bg: '#BC570F' }}
                        _focus={{ bg: '#BC570F' }}
                        value="gift"
                        borderWidth="0"
                        h={{ base: '32px', md: '44px' }}
                        border="0px solid #CE6113 !important"
                        mt={{
                          base: '27px',
                          lg:
                            region === 'us' || region === 'ca'
                              ? '30px'
                              : '23px',
                        }}
                        mr={{
                          base:
                            region === 'us' || region === 'ca'
                              ? '-30px'
                              : '20px',
                          md: '20px',
                        }}
                        target="_blank"
                      >
                        {sectionContent[8]?.buttonText}
                      </Link>
                    </NextLink>
                  </Flex>
                )}
              {!router.asPath.includes('/inner-engineering-pc-3') &&
                sectionContent[4]?.linkUrl && (
                  <Flex
                    flexDir="column"
                    alignItems="flex-end"
                    justify="space-between"
                  >
                    <Box
                      as="span"
                      fontSize={{ base: '12px', md: '14px' }}
                      color={{ base: '#979AF9', md: '#fff' }}
                      {...TopBannerSt[lang]?.loginButton}
                      letterSpacing={{ base: 'normal', md: '0' }}
                      fontWeight={{ base: '450', md: '500' }}
                      textAlign="end"
                      w="auto"
                      pb={{ base: '0px', md: '8px' }}
                      mt={{ base: '16px', md: '8px' }}
                    >
                      {/* Already registered text */}
                      {sectionContent[3]?.text}
                    </Box>
                    <NextLink
                      href={
                        isLoggedIn
                          ? sectionContent[4]?.linkUrl
                          : config.EMAIL_LOGIN_URL.replace('[EMAIL]', '')
                      }
                      passHref
                      legacyBehavior
                    >
                      <Link
                        id="banner-login-button"
                        {...TopBannerSt[lang]?.loginButton}
                        // variant="outline"
                        color={{ base: '#fff' }}
                        fontWeight={500}
                        height={{ base: '100%', md: '43px' }}
                        padding={{
                          base: lang == 'es' ? '3px 10px' : '3px 21px',
                          md: '5px 30px 11px',
                          lg: '5px 10px',
                        }}
                        fontSize={{ base: '14px', md: '18px' }}
                        borderRadius={0}
                        textAlign="center"
                        w={{ base: 'max-content', lg: '136px' }}
                        _hover={{
                          bg: '#BC570F',
                          color: '#fff',
                          border: '2px solid #BC570F !important',
                        }}
                        _active={{
                          bg: '#BC570F',
                          color: '#fff',
                          border: '2px solid #BC570F !important',
                        }}
                        _focus={{
                          bg: region !== 'us' && region !== 'ca' && '#BC570F',
                          color: '#fff',
                          border: '2px solid #BC570F !important',
                        }}
                        value="login"
                        h={{ base: 'auto', md: 'auto' }}
                        borderWidth="0"
                        border="2px solid #CE6113 !important"
                        mt={{
                          base: '8px',
                          lg: region === 'us' || region === 'ca' ? '8px' : '0',
                        }}
                        target="_blank"
                      >
                        {sectionContent[4]?.buttonText}
                      </Link>
                    </NextLink>
                  </Flex>
                )}
            </Flex>
            <Box
              mx="auto"
              maxW="1130px"
              px="20px"
              w="full"
              h="100%"
              display="flex"
              justifyContent={{ base: 'center', md: 'flex-start' }}
            >
              <Flex
                mt={{
                  base: '20px',
                  md: '0px',
                  lg: '50px',
                }}
                flexDirection="column"
                maxW={{
                  base: '100%',
                  sm: 'max(40%, 380px)',
                  md: '400px',
                  lg: '585px',
                  xl: '70%',
                }}
                textAlign={{ base: 'center', lg: 'left' }}
                alignItems={{ base: 'center', lg: 'left' }}
              >
                {isMobile && (
                  <SingleImage
                    mt={{ base: '80px', md: '90px' }}
                    mx={{ base: 'auto', md: '25px' }}
                    className="textImage"
                    objectFit="contain"
                    alignSelf={{
                      base: 'center',
                      md: 'flex-start',
                    }}
                    w="170px"
                    maxW={'170px'}
                    sectionContent={sectionContent[0]}
                    alt="in 7 step transform your life"
                    sync="true"
                  />
                )}

                <Box
                  w={{
                    base: '100%',

                    md: '90%',
                    lg: 'fit-content',
                  }}
                  pt={{ base: '20px', md: '0px', xl: '20px' }}
                  pr={{ lg: '35px' }}
                >
                  {sectionContent?.[2]?.body && (
                    <StructuredTextParser
                      str={render(sectionContent[2]?.body)}
                      color="#fff"
                      fontFamily="'FedraSansStd-medium'"
                      fontWeight="500"
                      fontSize={{
                        base: '26px',
                        md: '32px',
                        lg: '60px',
                      }}
                      pb={{ base: '20px', lg: '40px' }}
                      pr={{ base: '0', xl: '205px' }}
                      textAlign={{ base: 'center', md: 'start' }}
                    />
                  )}

                  {sectionContent?.[3]?.body && (
                    <StructuredTextParser
                      str={render(sectionContent[3]?.body)}
                      pb="20px"
                      fontFamily="'FedraSansStd-book'"
                      fontWeight="500"
                      fontSize={{ base: '20px', lg: '28px', xl: '34px' }}
                      color="#fff"
                      textAlign={{ base: 'center', md: 'start' }}
                    />
                  )}
                </Box>
              </Flex>
            </Box>

            <Box
              pos={{ base: 'static', md: 'absolute' }}
              h={{
                base: '196px',
                md: '445px',
                lg: '570px',
                xl: '630px',
              }}
              top={{ base: 'unset', md: 'unset', lg: 'unset' }}
              bottom={{ base: '0', md: '-80px', lg: '-207px', xl: '-120px' }}
              right={{
                base: '0%',
                lg: '0%',
                xl: '0%',
                '2xl': '10%',
              }}
              w={{
                base: '100%',
                sm: 'auto',
                md: '440px',
                lg: '500px',
                xl: '600px',
              }}
              display="flex"
              alignItems="baseline"
              justifyContent={{ base: 'center', md: 'unset' }}
            >
              <Image
                px="0"
                w={{ base: '100%', sm: 'auto', md: 'auto' }}
                objectPosition="top"
                mx={{ base: '0', sm: 'auto', md: '0' }}
                maxWidth={{ base: '200px', md: '370px', xl: '520px' }}
                height="auto"
                my="0"
                src={sectionContent[1].image.url}
                alt={sectionContent[1].image.title}
              />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default RemrktTopBanner;
